import { Flex, Text } from "@chakra-ui/react";
import { KeyboardEvent } from "react";

interface Props {
  title: string;
  values: string[];
  onClick?: () => void;
  icon?: JSX.Element;
  color?: string;
}

export const Stat = ({ title, values, onClick, icon, color }: Props) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (!onClick) return;
    if (event.key === "Enter" || event.key === " ") onClick();
  };
  return (
    <Flex
      width="full"
      justifyContent="space-between"
      alignItems="center"
      columnGap="5"
      rounded="lg"
      shadow="md"
      backgroundColor="smBackground"
      cursor={onClick ? "pointer" : "default"}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : -1}
      border="1px solid"
      borderColor="smBorder"
      px="6"
      pt="5"
      pb="8"
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <Flex flexDirection="column">
        <Text color="smMuted" fontWeight="semibold">
          {title}
        </Text>
        {values.map((value, index) => (
          <Text key={index} color={color}>
            {value}
          </Text>
        ))}
      </Flex>
      {icon && icon}
    </Flex>
  );
};
